import { render } from "./NewGroups.vue?vue&type=template&id=441930ed&scoped=true"
import script from "./NewGroups.vue?vue&type=script&lang=js"
export * from "./NewGroups.vue?vue&type=script&lang=js"

import "./NewGroups.vue?vue&type=style&index=0&id=441930ed&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441930ed"]])

export default __exports__